


























































import { Vue, Component } from "vue-property-decorator";
import { BAvatar, BDropdown, BDropdownDivider, BDropdownItem, BBadge } from "bootstrap-vue";
import { CompanyPricingPlan, Currency, IAuthLoginResultDto, ICompanyPricing, Locale } from "@lib";
import AltIcon from "@/core/components/alt-icon";
import { PricingLogic } from "@/core/logic";
import { Formatter } from "@/utils/formatter";
import { configuration } from "@/configuration";

@Component({
    components: {
        BAvatar,
        BDropdown,
        BDropdownDivider,
        BDropdownItem,
        BBadge,
        AltIcon,
    },
})
export default class ProfileDropdown extends Vue {
    public readonly DocsVisible = this.$alt.config.common.documentationEnabled;
    public readonly DocsUrl = this.$alt.config.url.docs;

    public pricing: ICompanyPricing | null = null;
    public balance: number | null = null;

    public get balanceCritical(): number {
        return this.pricing ? PricingLogic.getPricingPlanPrice(this.pricing.plan) : 0;
    }

    public get balanceWarning2(): number {
        return this.pricing ? PricingLogic.getPricingPlanPrice(this.pricing.plan) * 2 : 0;
    }

    public get balanceWarning1(): number {
        return this.pricing ? PricingLogic.getPricingPlanPrice(this.pricing.plan) * 3 : 0;
    }

    public get balanceFormatted(): string {
        const pricingPlan = this.pricing?.plan ?? CompanyPricingPlan.Free10;
        const locale = this.pricing?.locale ?? PricingLogic.getPricingPlanLocale(pricingPlan);
        const currency = this.pricing?.currency ?? PricingLogic.getPricingPlanCurrency(pricingPlan);
        return Formatter.money(this.balance, { locale, currency });
    }

    public get showLogoutCompanyButtons(): boolean {
        return this.$alt.isFeatureEnabled("feature-switch-company");
    }

    public async created(): Promise<void> {
        if (process.env.VUE_APP_ADMIN_MODE) {
            return;
        }

        await this.init();
    }

    private async init(): Promise<void> {
        try {
            this.pricing = await this.$info.getPricing();
            this.balance = this.pricing?.plan === CompanyPricingPlan.Free10 ? null : await this.$info.getBalance();

            this.$info.onBalanceChanged = (balance: number) => {
                this.balance = balance;
            };
        } catch {
            //
        }
    }

    private profile(): void {
        this.$router.push("/settings/profile").catch(() => {});
    }

    private company(): void {
        this.$router.push("/settings/company").catch(() => {});
    }

    private payment(): void {
        // TODO: сделать переход к оплате
        //this.$router.push({ path: 'settings', query: { payment: '' } }).catch(() => {})
        this.$router.push("/settings/company/payments").catch(() => {});
    }

    private async logoutCompany(): Promise<void> {
        const yes = await this.$alt.message.confirm("Вы уверены, что хотите сменить компанию?", "Смена компании", {
            acceptText: "Да",
            cancelText: "Нет",
            color: "primary",
        });

        if (yes) {
            await this.doLogoutCompany();
        }
    }

    private async doLogoutCompany(): Promise<void> {
        try {
            const result = await this.$alt.system.usecase.createAuthCompanyUseCase().logoutCompany();
            this.applyUserOnlyData(result);
            await this.$router.push({ name: "switch-company" }).catch(() => {});
        } catch (e: any) {
            this.$alt.toast.error(e.message);
        }
    }

    private async applyUserOnlyData(result: IAuthLoginResultDto): Promise<void> {
        this.$alt.system.token.cleanData();
        this.$alt.system.token.setUserOnlyToken(result.accessToken);

        this.$info.setAuthInfo(result.data);
        this.$settings.setUserInfo(result.data.user.user.id);
    }

    private async logout(): Promise<void> {
        const yes = await this.$alt.message.confirm("Вы уверены, что хотите выйти?", "Выход", {
            acceptText: "Да",
            cancelText: "Нет",
            color: "primary",
        });

        if (yes) {
            await this.doLogout();
        }
    }

    private async doLogout(): Promise<void> {
        try {
            this.$secure.reset();
            this.$info.clean();
            this.$alt.system.token.cleanData();

            await this.$router.push({ name: "login" }).catch(() => {});
        } catch (e: any) {
            this.$alt.toast.error(e.message);
        }
    }
}
